import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Eyebrow } from "@/components/Eyebrow";
import { Plus, Trash2 } from "lucide-react";

export function SavedBrandsSheet({ open, onOpenChange, brands = [], currentId, onLoad, onNew, onDelete }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="thin-scroll"
        style={{ background: "var(--panel)", borderRight: "1px solid var(--line)", width: 340, maxWidth: "85vw", overflowY: "auto" }}
        data-testid="saved-brands-sheet"
      >
        <SheetHeader>
          <SheetTitle asChild>
            <div><Eyebrow>Saved Brands</Eyebrow></div>
          </SheetTitle>
          <SheetDescription className="sr-only">Revisit a previously analyzed brand's DNA and generated assets.</SheetDescription>
        </SheetHeader>

        <button data-testid="new-session-button" className="btn-secondary" style={{ width: "100%", marginTop: 18 }} onClick={onNew}>
          <Plus size={14} /> New Session
        </button>

        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }} data-testid="saved-brands-list">
          {brands.length === 0 && (
            <div className="font-mono" style={{ fontSize: 12, color: "var(--tmuted)" }}>// no saved brands yet</div>
          )}
          {brands.map((b) => (
            <div
              key={b.id}
              className="panel-card"
              data-testid={`saved-brand-${b.id}`}
              onClick={() => onLoad(b.id)}
              style={{ padding: 12, cursor: "pointer", border: b.id === currentId ? "1px solid var(--orange)" : undefined }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                <div style={{ minWidth: 0 }}>
                  <div className="font-display" style={{ fontSize: 14, fontWeight: 600, color: "var(--tprimary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {b.siteName}
                  </div>
                  <div className="font-mono" style={{ fontSize: 10, color: "var(--tmuted)", marginTop: 3 }}>
                    {b.assetCount || 0} assets · {b.updated_at ? new Date(b.updated_at).toLocaleDateString() : ""}
                  </div>
                </div>
                <button
                  data-testid={`delete-brand-${b.id}`}
                  onClick={(e) => { e.stopPropagation(); onDelete(b.id); }}
                  style={{ background: "transparent", border: "none", color: "var(--tmuted)", cursor: "pointer", flexShrink: 0 }}
                  aria-label="Delete brand"
                >
                  <Trash2 size={14} />
                </button>
              </div>
              <div style={{ display: "flex", gap: 5, marginTop: 10 }}>
                {(b.colors || []).slice(0, 6).map((c, i) => (
                  <span key={`${c}-${i}`} style={{ width: 18, height: 18, borderRadius: 4, background: c, border: "1px solid rgba(255,255,255,0.08)" }} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
